const Process = () => {
  const steps = [
    {
      number: "01",
      title: "Requirement Gathering",
      description: "We meet with you online or face-to-face to understand your needs, goals, and vision for your project.",
      icon: "📋"
    },
    {
      number: "02",
      title: "Quotation & Timeline",
      description: "We provide a detailed quotation and set a clear timeline. Once agreed, we're ready to start.",
      icon: "📄"
    },
    {
      number: "03",
      title: "Initial Deposit",
      description: "A simple 20% initial deposit secures your project and gets us started on your solution.",
      icon: "💳"
    },
    {
      number: "04",
      title: "Prototype & Alignment",
      description: "We develop a prototype and show it to you, ensuring everything aligns with your expectations before final development.",
      icon: "🎨"
    },
    {
      number: "05",
      title: "Go Live",
      description: "Your project is complete, tested, and launched. Welcome to your new digital presence!",
      icon: "🚀"
    }
  ];

  return (
    <section id="process" className="w-full py-24 relative overflow-hidden bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 rounded-full bg-purple-500/10 border border-purple-500/30">
            <span className="text-purple-600 text-sm font-semibold">Our Process</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Simple & <span className="bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent">Straightforward</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            From initial consultation to successful delivery, we make the process easy and transparent.
          </p>
        </div>

        {/* Desktop Timeline View */}
        <div className="hidden md:block relative">
          {/* Connecting Line */}
          <div className="absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-purple-200 via-purple-400 to-pink-400 transform translate-y-1/2"></div>
          
          <div className="grid grid-cols-5 gap-4 relative items-stretch">
            {steps.map((step, index) => (
              <div key={index} className="relative flex">
                {/* Step Card */}
                <div className="bg-white rounded-2xl p-6 border-2 border-gray-200 hover:border-purple-400 transition-all duration-300 transform hover:-translate-y-2 hover:shadow-xl shadow-lg flex flex-col w-full">
                  {/* Step Number Badge */}
                  <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-pink-600 flex items-center justify-center text-white font-bold text-lg shadow-lg z-10">
                    {step.number}
                  </div>
                  
                  <div className="mt-8 text-center flex flex-col flex-grow">
                    <div className="text-4xl mb-4">{step.icon}</div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{step.title}</h3>
                    <p className="text-sm text-gray-600 leading-relaxed flex-grow">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Vertical Timeline View */}
        <div className="md:hidden space-y-8">
          {steps.map((step, index) => (
            <div key={index} className="relative flex gap-4">
              {/* Vertical Line */}
              {index < steps.length - 1 && (
                <div className="absolute left-6 top-16 bottom-0 w-0.5 bg-gradient-to-b from-purple-400 to-pink-400"></div>
              )}
              
              {/* Step Number Circle */}
              <div className="relative z-10 flex-shrink-0 w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-pink-600 flex items-center justify-center text-white font-bold shadow-lg">
                {step.number}
              </div>
              
              {/* Step Content */}
              <div className="flex-1 bg-white rounded-xl p-6 border-2 border-gray-200 shadow-lg min-h-[140px] flex flex-col">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-3xl">{step.icon}</span>
                  <h3 className="text-lg font-bold text-gray-900">{step.title}</h3>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed flex-grow">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-8 border border-purple-200 max-w-2xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Ready to Get Started?</h3>
            <p className="text-gray-600 mb-6">
              Our process is designed to be simple, transparent, and stress-free. Let's bring your vision to life.
            </p>
            <a
              href="#contact"
              className="inline-block px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white font-semibold rounded-full hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
            >
              Start Your Project
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;

